import {
    validateAdviser,
    validateAppointmentType,
    validateDate,
    validateEndTime,
    validateLocation,
    validateService,
    validateStartTime,
    validateTeam
} from './validationFunctions';

export const validateSlots = (newEntry) => {
    let newErrors = {};
    newErrors = validateService(newEntry.serviceId, newErrors);
    newErrors = validateTeam(newEntry.teamId, newErrors);
    newErrors = validateAdviser(newEntry.userId, newErrors);
    newErrors = validateAppointmentType(newEntry.typeId, newErrors);
    newErrors = validateLocation(newEntry.locationId, newErrors);
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);
    newErrors = validateDate(newEntry.date, newErrors);

    return newErrors;
};
